<script setup lang="ts">
    import SubNavigation from '../../components/navigation/SubNavigation.vue';
    import BackOfficeSubNavigation from '../components/BackOfficeSubNavigation.vue';
</script>
<template>
    <SubNavigation>
        <template #subnavigation>
            <BackOfficeSubNavigation />
        </template>

        <RouterView />
    </SubNavigation>
</template>
